<template>
  <div class="mt-12 sm:mt-8 pb-28 md:mt-12">
    <div class="relative">
      <div class="flex flex-row justify-between items-center">
        <h3 class="text-subtitle4 pb-4 md:pb-6">Referral history</h3>
      </div>
      <div class="relative max-w-80 min-w-full sm:max-w-none">
        
        <div class="w-full overflow-auto">
          <table class="w-full caption-bottom text-sm">
            <thead class="[&_tr]:border-b text-t-third bg-interactive-interactiveBg">
              <tr
                class="border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted border-none bg-transparent">
                <th
                  class="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 whitespace-nowrap pl-4 pr-4 sticky top-0 z-30 !text-body1 shadow-[inset_1px_0_0_rgb(var(--colors-border-line)),inset_0_1px_0_rgb(var(--colors-border-line)),inset_0_-1px_0_rgb(var(--colors-border-line))] py-px bg-clip-padding">
                  Friend's address</th>
                <th
                  class="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 whitespace-nowrap pl-4 pr-4 sticky top-0 z-30 !text-body1 shadow-[inset_0_1px_0_rgb(var(--colors-border-line)),inset_0_-1px_0_rgb(var(--colors-border-line))] py-px bg-clip-padding">
                  <button type="button" class="flex items-center">
                    Date joined
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="hidden dark:block text-t-third rotate-180 w-4 h-4">
                      <path d="M8.39984 13.3333L12.6665 9.06665L4.13317 9.06665L8.39984 13.3333Z"
                        fill="currentColor"></path>
                      <path d="M8.39997 2.66668L4.1333 6.93335L12.6666 6.93335L8.39997 2.66668Z" fill="white">
                      </path>
                    </svg>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="block dark:hidden text-t-third rotate-180 w-4 h-4">
                      <path d="M8.39984 13.3333L12.6665 9.06665L4.13317 9.06665L8.39984 13.3333Z"
                        fill="currentColor"></path>
                      <path d="M8.39997 2.66668L4.1333 6.93335L12.6666 6.93335L8.39997 2.66668Z"
                        fill="rgb(21,21,21)"></path>
                    </svg>
                  </button>
                </th>
                <th
                  class="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 whitespace-nowrap pl-4 pr-4 sticky top-0 z-30 !text-body1 shadow-[inset_0_1px_0_rgb(var(--colors-border-line)),inset_0_-1px_0_rgb(var(--colors-border-line))] py-px bg-clip-padding">
                  <button type="button" class="flex items-center">
                    Total volume (USDT)
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="text-t-third w-4 h-4">
                      <path d="M8.39984 13.3333L12.6665 9.06665L4.13317 9.06665L8.39984 13.3333Z"
                        fill="currentColor"></path>
                      <path d="M8.39997 2.66668L4.1333 6.93335L12.6666 6.93335L8.39997 2.66668Z"
                        fill="currentColor"></path>
                    </svg>
                  </button>
                </th>
                <th
                  class="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 whitespace-nowrap pl-4 pr-4 sticky top-0 z-30 !text-body1 shadow-[inset_0_1px_0_rgb(var(--colors-border-line)),inset_0_-1px_0_rgb(var(--colors-border-line))] py-px bg-clip-padding hidden md:table-cell">
                  <button type="button" class="flex items-center">
                    Fees paid (USDT)
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="text-t-third w-4 h-4">
                      <path d="M8.39984 13.3333L12.6665 9.06665L4.13317 9.06665L8.39984 13.3333Z"
                        fill="currentColor"></path>
                      <path d="M8.39997 2.66668L4.1333 6.93335L12.6666 6.93335L8.39997 2.66668Z"
                        fill="currentColor"></path>
                    </svg>
                  </button>
                </th>
                <th
                  class="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 whitespace-nowrap pl-4 pr-4 sticky top-0 z-30 !text-body1 shadow-[inset_-1px_0_0_rgb(var(--colors-border-line)),inset_0_1px_0_rgb(var(--colors-border-line)),inset_0_-1px_0_rgb(var(--colors-border-line))] py-px bg-clip-padding hidden md:table-cell">
                  <button type="button" class="flex items-center">
                    Your rewards (USDT)
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="text-t-third w-4 h-4">
                      <path d="M8.39984 13.3333L12.6665 9.06665L4.13317 9.06665L8.39984 13.3333Z"
                        fill="currentColor"></path>
                      <path d="M8.39997 2.66668L4.1333 6.93335L12.6666 6.93335L8.39997 2.66668Z"
                        fill="currentColor"></path>
                    </svg>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody class="[&_tr:last-child]:border-0"></tbody>
          </table>
        </div>
        <p class="flex h-[12.5rem] items-center justify-center text-body1 text-t-primary">The referrer has decided to hide the connection history to their profile in order to prevent insider trading.</p>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPageReferralHistorySection'
}
</script>

<style scoped>
/* Все стили будут добавлены через глобальные CSS файлы */
</style>

